import React, { lazy } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { IconsPreview } from '@nw/shared/ui';
import { componentLoader } from '@nw/shared/utils';

import ProtectedRoute from '../components/ProtectedRoute';
import SRPaymentE2ERoute from '../components/SRPaymentE2ERoute';
import {
  ICONS_PREVIEW_ROUTE_PATH,
  INSTALLMENT_ORDER_STATUS_CHECK_ROUTE_PATH,
  LOGIN_ROUTE,
  NAT_REPORT_ROUTE_PATH,
  NIAT_APPLICATION_PORTAL_HOME_ROUTE,
  NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH,
  ORDER_STATUS_CHECK_ROUTE_PATH,
  SAMPLE_REPORT_ROUTE_PATH,
  SHARE_NAT_REPORT_ROUTE_PATH
} from '../constants/RouteConstants';
import { isDevEnvironment } from '../utils/EnvironmentUtils';

import HomeAndExamRoute from './HomeAndExamRoute';

const LoginPageRoute = lazy(
  () =>
    componentLoader(
      () => import(/* webpackChunkName: "LoginPageRoute" */ './LoginPageRoute')
    ) as Promise<{ default: React.ComponentType<any> }>
);

const OrderStatusCheckRoute = lazy(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "OrderStatusCheckRoute" */ '../components/OrderStatusCheckRoute'
        )
    ) as Promise<{ default: React.ComponentType<any> }>
);

const InstallmentOrderStatusCheckRoute = lazy(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "InstallmentOrderStatusCheckRoute" */ '../components/InstallmentOrderStatusCheckRoute'
        )
    ) as Promise<{ default: React.ComponentType<any> }>
);

const NatResultsRoute = lazy(
  () =>
    componentLoader(
      () => import(/* webpackChunkName: "NatReultsRoute" */ './NatResultsRoute')
    ) as Promise<{ default: React.ComponentType<any> }>
);

const SampleReportRoute = lazy(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "SampleReportRoute" */ './SampleReportRoute'
        )
    ) as Promise<{ default: React.ComponentType<any> }>
);

const ShareableNAtResultsRoute = lazy(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "ShareableNAtResultsRoute" */ './ShareableNAtResultsRoute'
        )
    ) as Promise<{ default: React.ComponentType<any> }>
);

const FixedProtectedRoute = ProtectedRoute as any;

export const routes = [
  <Route
    exact
    path={LOGIN_ROUTE}
    key={'loginPage'}
    component={LoginPageRoute}
  />,
  <Route
    exact
    path={`${SHARE_NAT_REPORT_ROUTE_PATH}/:u_id/:s_id`}
    key={'shareableNatResults'}
    component={ShareableNAtResultsRoute}
  />,
  <Route
    exact
    path={SAMPLE_REPORT_ROUTE_PATH}
    key={'sampleReportPage'}
    component={SampleReportRoute}
  />,
  <FixedProtectedRoute
    exact
    path={`${NAT_REPORT_ROUTE_PATH}/:u_id/:s_id`}
    key="natReportPage"
    component={NatResultsRoute}
  />,
  <FixedProtectedRoute
    exact
    path={[
      NIAT_APPLICATION_PORTAL_HOME_ROUTE,
      NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH
    ]}
    key="homeAndExamRoute"
    component={HomeAndExamRoute}
  />,
  <FixedProtectedRoute
    exact
    path={ORDER_STATUS_CHECK_ROUTE_PATH}
    key={ORDER_STATUS_CHECK_ROUTE_PATH}
    component={OrderStatusCheckRoute}
  />,
  <FixedProtectedRoute
    exact
    path={INSTALLMENT_ORDER_STATUS_CHECK_ROUTE_PATH}
    key={INSTALLMENT_ORDER_STATUS_CHECK_ROUTE_PATH}
    component={InstallmentOrderStatusCheckRoute}
  />,
  ...(isDevEnvironment()
    ? [
        <Route
          exact
          path="/e2e/niat/sr-payment"
          key="niatSrPaymentE2eRoute"
          component={SRPaymentE2ERoute}
        />,
        <Route
          exact
          path={ICONS_PREVIEW_ROUTE_PATH}
          key={ICONS_PREVIEW_ROUTE_PATH}
          component={IconsPreview}
        />
      ]
    : []),
  <Route
    path="*"
    render={({ location }) => (
      <Redirect
        to={{
          pathname: NIAT_APPLICATION_PORTAL_HOME_ROUTE,
          search: location.search
        }}
      />
    )}
  />
];
